export var EAddressType;
(function (EAddressType) {
    EAddressType["INVOICE"] = "invoice";
    EAddressType["DELIVERY"] = "delivery";
})(EAddressType || (EAddressType = {}));
